import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const COMPLIANCE_SETTINGS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('COMPLIANCE_SETTINGS');
export const COMPLIANCE_SETTINGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	COMPLIANCE_SETTINGS_CRUD_ACTION_CONSTANTS
);
